/* eslint-disable */
export default {
  inAMeeting: 'Em uma reunião',
  onMyWay: 'Estou a caminho',
  callMeBackIn: 'Ligue para mim em...',
  willCallYouBackIn: 'Retornarei a chamada em...',
  hour: 'hora',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
